import { render, staticRenderFns } from "./AttachmentSelector.vue?vue&type=template&id=11cb78b2"
import script from "./AttachmentSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentSelector.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports